export const state = () => ({
	//data:{},
	applicationsPerMonth: {},
	jobViewsPerDay: {},
	publishedJobs: 0,
	totalApplicants: 0,
	availableTokens: {},
	totalProspects: 0,
	pendingPlacements: 0,
});
export const mutations = {
	setApplicationsPerMonth(state: any, payload: any) {
		state.applicationsPerMonth = payload;
	},
	setJobViewsPerDay(state: any, payload: any) {
		state.jobViewsPerDay = payload;
	},
	setPublishedJobs(state: any, payload: any) {
		state.publishedJobs = payload;
	},
	setTotalApplicants(state: any, payload: any) {
		state.totalApplicants = payload;
	},
	setAvailableTokens(state: any, payload: any) {
		state.availableTokens = payload;
	},
	setTotalProspects(state: any, payload: any) {
		state.totalProspects = payload;
	},
	setPendingPlacements(state: any, payload: any) {
		state.pendingPlacements = payload;
	},
};
export const getters = {
	getApplicationsPerMonth: (state: any) => state.applicationsPerMonth,
	getJobViewsPerDay: (state: any) => state.jobViewsPerDay,
	getPublishedJobs: (state: any) => state.publishedJobs,
	getTotalApplicants: (state: any) => state.totalApplicants,
	getAvailableTokens: (state: any) => state.availableTokens,
	getTotalProspects: (state: any) => state.totalProspects,
	getPendingPlacements: (state: any) => state.pendingPlacements,
};
export const actions = {
	async getData(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/dashboard/' + payload)
				.then((res) => {
					state.commit('setApplicationsPerMonth', res.data.applicationsPerMonth);
					state.commit('setJobViewsPerDay', res.data.jobViewsPerDay);
					state.commit('setPublishedJobs', res.data.publishedJobs);
					state.commit('setTotalApplicants', res.data.totalApplicants);
					state.commit('setAvailableTokens', res.data.availableTokens);
					state.commit('setTotalProspects', res.data.totalProspects);
					state.commit('setPendingPlacements', res.data.pendingPlacements);

					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
};
